module.exports = __webpack_public_path__ + "img/pt-single-4.5aff3b7c.jpg";